import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform, LoadingController, ToastController, ActionSheetController, ActionSheet } from 'ionic-angular';
import { Network } from '@ionic-native/network';
import { BasePage } from '../../models/basePage';
import { Http } from "@angular/http";

import { API } from '../../services/api/api.services';
import { pouchdb, iDesignacionesAPI } from '../../services/pouchdb/pouchdb.service';
import { Designaciones_API } from '../../models/designaciones';

@IonicPage()
@Component({
  selector: 'page-designaciones-completas',
  templateUrl: 'designaciones-completas.html',
})
export class DesignacionesCompletasPage extends BasePage {

  // #region  Propiedades del controlador
  private todasDesignaciones: Array<Designaciones_API> = [];
  // #endregion

  constructor(public navCtrl: NavController, public navParams: NavParams, public platform: Platform, public http: Http, public loadingCtrl: LoadingController, public toastCtrl: ToastController, public network: Network, public DBService: pouchdb.DBService, public actionSheetCtrl: ActionSheetController, public DesignacionesService: API.DesignacionesService) {
    super(navCtrl, platform, http, toastCtrl, DBService, loadingCtrl);
  }

  ionViewDidLoad() { }

  ionViewDidEnter() {
    this.TodasLasDesignaciones();
  }

  // #region Métodos del controlador

  public ColorDesignacion(designacion: iDesignacionesAPI): string {
    let resultado: string = '';
    if (designacion != null) {
      switch (designacion.jugado) {
        case 1:
          resultado = 'alizarin';
          break;
        case 2:
          resultado = 'turquoise';
          break;

        case 3:
          resultado = 'orange';
          break;

        case 4:
          resultado = 'sun-flower';
          break;
      }
    }
    return resultado;
  }

  /**
   * Envía los datos completos de la designación al servidor, para que se guarden en el registro de sincronización
   * @param designacion Datos de la designación
   */
  public Test(designacion: iDesignacionesAPI): void {
    let conexion: string = this.network.type != null ? this.network.type.toString() : 'pruebas';
    console.log(conexion);
    if (conexion != 'none') {
      let action: ActionSheet = this.actionSheetCtrl.create({
        title: 'Enviar designación al servidor',
        subTitle: 'Al pulsar sobre la designación seleccionada, todos sus datos se enviarán al servidor y se guardarán en el registro de sincronizaciones. ¿Desea realizar el envío?',
        buttons: [
          {
            text: 'CONFIRMAR',
            handler: () => {
              this.MostrarCarga();

              // Nueva instancia de la designación a enviar
              let datosDesignacion: iDesignacionesAPI = Object.assign({}, designacion);
              datosDesignacion.urlApi = designacion.urlApi;
              datosDesignacion.urlNombre = designacion.urlNombre;

              // Se comprueba que la designación tiene su modelo correcto para enviarlo al servidor.
              this.CondicionesFinalizacion(datosDesignacion, true);

              // Eliminación de todas las firmas
              datosDesignacion = this.EliminarFirmas(datosDesignacion);

              this.DesignacionesService.test(datosDesignacion)
                .then((resultado: boolean) => {
                  if (resultado) {
                    this.Mensaje('Se ha realizado correctamente el envío de los datos de la designación al servidor.', '', 0);

                    this.GuardarLog(JSON.stringify(datosDesignacion), "designaciones-completas", "Test", "Se ha enviado correctamente los datos de la designación al servidor: Test.");
                  }
                  else {
                    this.Mensaje('No se ha podido completar la información de envío al servidor.', '', 0);
                    this.GuardarLog(JSON.stringify(datosDesignacion), "designaciones-completas", "Test", "No se ha podido completar la información de envío al servidor.");
                  }
                  this.OcultarCarga();
                })
                .catch((error) => this.Error(JSON.stringify(error), "designaciones-completas", "Test", "ERROR: Enviando los datos de la designación al servidor: Test."));
            }
          },
          {
            text: 'Cancelar',
            role: 'cancel'
          }
        ]
      });
      action.present();
    }
    else {
      this.Mensaje('No se puede realizar la operación porque no se dispone de conexión a Internet', '', 0);
    }
  }

  /**
   * Obtiene la lista de todas las designaciones guardadas en el dispositivo
   */
  public TodasLasDesignaciones(): void {
    this.MostrarCarga();
    this.todasDesignaciones = [];

    this.DBService.DesignacionesGetAll()
      .then((resultado: PouchDB.Find.FindResponse<iDesignacionesAPI>) => {
        console.log(resultado);
        if (resultado.docs != null && resultado.docs.length > 0) {
          resultado.docs.forEach((valor: PouchDB.Core.Document<iDesignacionesAPI>, i: number) => {
            this.todasDesignaciones.push(<iDesignacionesAPI>valor);
          });
        }
        else {
          this.Mensaje('No se han encontrado designaciones guardadas en este dispositivo', '', 0);
        }

        this.OcultarCarga();
      })
      .catch((error) => {
        this.Error(JSON.stringify(error), "designaciones-completas", "TodasLasDesignaciones", "ERROR: No se ha podido completar la información de envío al servidor.");
      });
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/designaciones-completas/designaciones-completas.ts